import classNames from 'classnames'
import 'react-reflex/styles.css'
import { useCurrentUser } from '../../../../modules/context/UserContext'
import { n_classroom, s_preparation } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { DocNoteTabPanel, IconOpenNewTab } from '../../../new-portal/review/DocNoteTabPanel'

export const StudentClassroomRightTabs = ({ ringleDocUrl, ringleDocToken }) => {
  const { currentUser } = useCurrentUser()
  const { t } = useTranslation()
  return (
    <>
      <div className={classNames('z-60 top-[70px] left-[0px] h-[52px] cursor-pointer bg-white px-[20px] shadow-sm')}>
        <div className="flex">
          <div className="flex h-[50px] w-full items-center justify-between">
            <div className="relative mx-[16px] h-[50px] pb-[14px] pt-[12px]">
              <div className={classNames('whitespace-nowrap text-black')}>
                <div className="Body1-16Bd relative flex items-center leading-[26px]">
                  {t(s_preparation.googleDocs)}
                </div>
              </div>
              <div
                style={{ transform: 'translateX(-50%)' }}
                className="transfrom absolute bottom-[-2px] left-1/2 h-[3px] w-full bg-black"
              ></div>
            </div>
            <div className="relative right-[30px] bottom-[4px]">
              <div className="flex items-center">
                <IconOpenNewTab ringleDocUrl={ringleDocUrl} token={ringleDocToken} currentUser={currentUser} />
                <div className="Body2-14Md ml-[4px] text-gray-700">{t(n_classroom.tab_note_newtab)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
type RightBodyPropsType = {
  docsRef: any
  documentUrl: any
  ringledocUrl: any
  ringleDocToken: any
  currentUser: any
  specialLesson: any
}

const StudentClassroomRightBody = ({
  docsRef,
  documentUrl,
  ringledocUrl,
  ringleDocToken,
  currentUser,
  specialLesson,
}: RightBodyPropsType) => {
  return (
    <div className="">
      <DocNoteTabPanel
        documentUrl={documentUrl}
        ringledocUrl={ringledocUrl}
        iframeRef={docsRef}
        ringleDocToken={ringleDocToken}
        currentUser={currentUser}
        specialLesson={specialLesson}
        height={'calc(100vh - 123px)'}
        style={'border-0 w-h-full w-full h-full'}
      />
    </div>
  )
}
export default StudentClassroomRightBody
